$w.onReady(function () {});